export default __webpack_public_path__ + "static/media/Menu.2c3801d6.svg";